import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormArray } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-cas-rh',
    templateUrl: './cas-rh.component.html',
    styleUrls: ['./cas-rh.component.css']
})
export class CasRhComponent implements OnInit {
    @Input() agentRow: any;
    cashForm: FormGroup;
    types: string[] = ['Promotion catégorielle', 'Augmentation de salaire', 'Gratification', 'Bonus', 'Contribution EIA', 'Autre'];

    bodyObject = {
        title: 'Liste des cas RH pour la campagne en cours',
        tableFields: [
            { header: '#', width: '1%', field: 'index', align: 'left' },
            { header: 'Type', width: '20%', field: 'type', align: 'left' },
            { header: 'Description', width: 'auto', field: 'description', align: 'left' },
            { header: 'Année', width: '16%', field: 'annee', align: 'left' },
        ]
    }

    constructor(private fb: FormBuilder, public activeModal: NgbActiveModal) { }

    ngOnInit() {
        this.cashForm = this.fb.group({
            items: this.fb.array([])
        });
    }

    get items() {
        return this.cashForm.get('items') as FormArray;
    }

    addItem() {
        const item = this.fb.group({
            type: [''],
            description: [''],
            annee: ['']
        });

        this.items.push(item);
    }

    removeItem(index: number) {
        this.items.removeAt(index);
    }

    onTypeChange(index: number) {
        const item = this.items.at(index);
        const selectedType = item.get('type').value;

        if (selectedType === 'Autre') {
            item.patchValue({
                description: 'En baisse depuis',
                annee: ''
            });
            item.get('description').disable();
            item.get('annee').disable();
        } else if (selectedType) {
            item.patchValue({
                description: `N'en a pas bénéficié depuis`,
                annee: ''
            });
            item.get('description').enable();
            item.get('annee').enable();
        } else {
            item.patchValue({
                description: '',
                annee: ''
            });
            item.get('description').enable();
            item.get('annee').enable();
        }
    }
}